import Phaser from 'phaser';
import { recordScore, isHighScore_, type HighScore } from '../storage/high-scores';
import { audio } from '../audio';

interface GameOverData {
  stats?: { time: number; kills: number; breeds: number; bestEmergent?: string[] };
}

export class GameOverScene extends Phaser.Scene {
  private stats?: GameOverData['stats'];
  private newRecord = false;

  constructor() {
    super({ key: 'GameOverScene' });
  }

  init(data: GameOverData): void {
    this.stats = data.stats;
    if (this.stats) {
      const entry: HighScore = {
        time: this.stats.time,
        kills: this.stats.kills,
        breeds: this.stats.breeds,
        bestEmergent: this.stats.bestEmergent ?? [],
        date: new Date().toISOString(),
      };
      this.newRecord = isHighScore_(entry);
      recordScore(entry);
    }
  }

  create(): void {
    audio.stopMusic(1.2);
    audio.play('runEnd');
    const { width, height } = this.scale.gameSize;
    const cx = width / 2;

    this.add
      .text(cx, height / 2 - 100, 'extinct', {
        fontFamily: 'system-ui',
        fontSize: '48px',
        color: '#ffffff',
      })
      .setOrigin(0.5);

    if (this.newRecord) {
      this.add
        .text(cx, height / 2 - 56, 'NEW HIGH SCORE', {
          fontFamily: 'system-ui',
          fontSize: '16px',
          color: '#ff9ec4',
        })
        .setOrigin(0.5);
    }

    if (this.stats) {
      const mm = String(Math.floor(this.stats.time / 60)).padStart(2, '0');
      const ss = String(this.stats.time % 60).padStart(2, '0');
      this.add
        .text(
          cx,
          height / 2 - 10,
          [
            `survived  ${mm}:${ss}`,
            `kills     ${this.stats.kills}`,
            `breeds    ${this.stats.breeds}`,
          ].join('\n'),
          {
            fontFamily: 'monospace',
            fontSize: '18px',
            color: '#c8c8c8',
            align: 'center',
            lineSpacing: 4,
          },
        )
        .setOrigin(0.5);

      if (this.stats.bestEmergent && this.stats.bestEmergent.length > 0) {
        this.add
          .text(cx, height / 2 + 90, this.stats.bestEmergent.join(' · '), {
            fontFamily: 'system-ui',
            fontSize: '13px',
            color: '#ff9ec4',
          })
          .setOrigin(0.5);
      }
    }

    this.add
      .text(cx, height / 2 + 140, 'click to return to title', {
        fontFamily: 'system-ui',
        fontSize: '14px',
        color: '#9aa0a6',
      })
      .setOrigin(0.5);

    this.input.once('pointerdown', () => {
      this.scene.start('TitleScene');
    });
  }
}
